// extracted by mini-css-extract-plugin
export default {"base":"Textarea_base__oigTQ"};